// Stores the viewer's personal star ratings (1-5) per title in localStorage.
const KEY = 'userRatingsDB'

function getAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {}
  } catch {
    return {}
  }
}

function get(id) {
  return getAll()[id] || 0
}

function set(id, value) {
  const all = getAll()
  if (value) all[id] = value
  else delete all[id]
  localStorage.setItem(KEY, JSON.stringify(all))
}

export const ratingService = { get, set }
